/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/assets-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/assets-api-client";
import type { AssetsAPIUploadUploadMutationRequest, AssetsAPIUploadUploadMutationResponse } from "../models/AssetsAPIUploadUpload";
import type { UseMutationOptions, QueryClient } from "@tanstack/react-query";
import { assetsAPIUploadUpload } from "../axios/assetsAPIUploadUpload";
import { useMutation } from "@tanstack/react-query";

export const assetsAPIUploadUploadMutationKey = () => ["assets-api", { url: '/assets' }] as const

export type AssetsAPIUploadUploadMutationKey = ReturnType<typeof assetsAPIUploadUploadMutationKey>

/**
 * @summary Upload asset
 * {@link /assets}
 */
export function useAssetsAPIUploadUpload<TContext>(options: 
{
  mutation?: UseMutationOptions<AssetsAPIUploadUploadMutationResponse, ResponseErrorConfig<Error>, {data: AssetsAPIUploadUploadMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<AssetsAPIUploadUploadMutationRequest>> & { client?: typeof fetch },
}
 = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? assetsAPIUploadUploadMutationKey()

  return useMutation<AssetsAPIUploadUploadMutationResponse, ResponseErrorConfig<Error>, {data: AssetsAPIUploadUploadMutationRequest}, TContext>({
    mutationFn: async({ data }) => {
      return assetsAPIUploadUpload(data, config)
    },
    mutationKey,
    ...mutationOptions
  }, queryClient)
}